<template>
    <v-card flat>
        <v-card-title primary-title>
            <div>
                <h3 class="subheading font-weight-regular mb-1 section-title--color">Sort</h3>
            </div>
        </v-card-title>
        <div class="px-3">
            <v-radio-group
                    :disabled="!monitorActionReady"
                    row
                    v-model="byType"
                    :mandatory="false"
                    class="mt-0 custom-radio-size"
                    @change="postFilter()"
            >
                <v-layout row wrap>
                    <v-flex :key="item.value" xs6 v-for="item in sortItemsType">
                        <v-radio class="mr-0" :ripple="false" color="bindezcolor" :value="item.value">
                            <template slot="label">
                                <span class="body-2 font-weight-regular" style="color:#777777; margin-left: -5px;" >{{ item.name }}</span>
                            </template>
                        </v-radio>
                    </v-flex>
                </v-layout>
            </v-radio-group>
        </div>
        <div class="pa-3">
            <v-select
                    :disabled="!monitorActionReady"
                    color="bindezcolor"
                    label="Sorting"
                    :items="sortItemsByOrder"
                    item-text="name"
                    item-value="value"
                    v-model="byOrder"
                    @change="postFilter()"
            />
        </div>
    </v-card>
</template>

<script>
	import {mapState, mapMutations} from 'vuex';

	export default {
		name: "PostFilter",
		data() {
			return {
				sortItemsType:[
                    {name: "Time", value:"time"},
                    {name: "Likes", value:"likes"},
                    {name: "Comments", value:"comments"},
                    {name: "Shares", value:"shares"},
                ],
				sortItemsByOrder: [
					{name: "Asc", value: "asc"},
					{name: "Desc", value: "desc"}
				],
			}
		},

		methods: {
			...mapMutations('mention', [
				'setSortByType',
				'setSortByOrder',
			]),

			postFilter() {
				this.$ua.trackEvent("Filter Post", "check", "Filter By Action");
				this.$emit('postFilter');
			}
		},

		computed: {
			...mapState('mention', [
				'sortByType',
				'sortByOrder',
			]),

			...mapState([
				'monitorActionReady'
			]),

			byType: {
				get() {
					return this.sortByType
				},
				set(value) {
					this.setSortByType(value);
				}
			},

			byOrder: {
				get() {
					return this.sortByOrder;
				},
				set(value) {
					this.setSortByOrder(value);
				}
			},
		}
	}
</script>

<style scoped>

</style>
